import { render, staticRenderFns } from "./RewardList.vue?vue&type=template&id=97062144&"
import script from "./RewardList.vue?vue&type=script&lang=js&"
export * from "./RewardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports